import { call, all, put, takeEvery } from 'redux-saga/effects';
import {
  getAnalyticsReportListSuccessAction,
  getAnalyticsReportListFailureAction,
  getAnalyticsAnalyticsSuccessReportAction,
  getAnalyticsAnalyticsFailureReportAction
} from '../../features/analyticsReports/analyticsReportsSlice';
import URLs from '../../../constants/urls';
import { GET_ANALYTICS_REPORT_LIST, GET_ANALYTICS_ANALYTICS_REPORT } from '../../actions/AnalyticsReports/actionTypes';
import { apiPython } from '../../../service/api';
const api = apiPython;
import { getSessionStorage } from '../../../utils/helpers';

export function* getAnalyticsReportListSaga() {
  try {
    const response = yield api.get(
      `${URLs.GET_ANALYTICS_REPORT_LIST}?permission_level=${getSessionStorage('PERMISSION_LEVEL')}&EmployeeType=${getSessionStorage(
        'USER_TYPE'
      )}&LoggedUserID=${getSessionStorage('USER_ID')}`
    );
    const raw = response.data?.data;
    yield put(getAnalyticsReportListSuccessAction(Array.isArray(raw) ? raw : []));
  } catch (error) {
    yield put(getAnalyticsReportListFailureAction(error));
  }
}

export function* getAnalyticsReportSaga({ payload: id }) {
  try {
    const response = yield api.get(
      `${URLs.GET_ANALYTICS_ANALYTICS_REPORT}?ReportID=${id}&permission_level=${getSessionStorage(
        'PERMISSION_LEVEL'
      )}&employeeType=internal`
    );
    yield put(getAnalyticsAnalyticsSuccessReportAction(response.data.data));
  } catch (error) {
    yield put(getAnalyticsAnalyticsFailureReportAction(error));
  }
}

export function* watchAnalyticsReport() {
  yield takeEvery(GET_ANALYTICS_REPORT_LIST, getAnalyticsReportListSaga);
  yield takeEvery(GET_ANALYTICS_ANALYTICS_REPORT, getAnalyticsReportSaga);
}

export default function* AnalyticsSaga() {
  yield all([watchAnalyticsReport()]);
}
